module.exports = __webpack_public_path__ + "img/tab-content-image-06.0e1253db.png";